import { Device, until } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import useMedia from '@hooks/useMedia';
import Button from '@stories/Elements/Forms/Buttons/Button';
import CultureFlag from '@stories/Elements/Misc/CultureFlag/CultureFlag';
import React, { FunctionComponent } from 'react';
import { CareerCardStyles } from './CareerCard.styles';

export interface CareerCardProps {
  career: CareerCardModel;
  index?: number;
  rowItems?: number;
}

const CareerCard: FunctionComponent<CareerCardProps> = ({
  career,
  index = 0,
  rowItems = useMedia([until(Device.MobileLarge), until(Device.DesktopSmall)], [2, 3], 5),
}) => {
  const [cardRef, cardInView] = useInView<HTMLAnchorElement>({ threshold: 0.15 });

  const baseDelay = 0;
  const indexDelay = index % rowItems;
  const delayInterval = baseDelay + indexDelay * 100;

  return (
    <CareerCardStyles.Card
      href={career.url}
      key={career.id}
      ref={cardRef}
      cardInView={cardInView}
      delay={delayInterval}
    >
      <CareerCardStyles.Details>
        <CareerCardStyles.Small>{career.department}</CareerCardStyles.Small>
        <CareerCardStyles.Title>{career.title}</CareerCardStyles.Title>
        <CareerCardStyles.ButtonWrapper>
          <Button text={career.buttonText} fakeButton={true} theme="black-grey" size="small" />
        </CareerCardStyles.ButtonWrapper>
      </CareerCardStyles.Details>
      <CareerCardStyles.Location>
        <CultureFlag cultureCode={career.location.cultureCode} />{' '}
        <span>
          {career.location.cultureCity}
          <br /> {career.location.cultureName}
        </span>
      </CareerCardStyles.Location>
    </CareerCardStyles.Card>
  );
};

export default CareerCard;
